var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarActionsImperfects = function SvgCarActionsImperfects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.189 8.689L20.25 6.75H3.75L1.811 8.689C1.13191 9.36832 0.750294 10.2895 0.75 11.25C0.75 11.6478 0.908035 12.0294 1.18934 12.3107C1.47064 12.592 1.85218 12.75 2.25 12.75H12.0374",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07495 9.75H5.24995",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75L5.45 2.21C5.61083 1.7807 5.89902 1.4108 6.27595 1.14986C6.65288 0.888918 7.10056 0.749402 7.559 0.750002H16.441C16.8989 0.750014 17.3459 0.889814 17.7223 1.15071C18.0986 1.41161 18.3863 1.78118 18.547 2.21L20.247 6.75H3.75Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.75V14.25C2.25 14.6478 2.40804 15.0294 2.68934 15.3107C2.97064 15.592 3.35218 15.75 3.75 15.75C4.14782 15.75 4.52936 15.592 4.81066 15.3107C5.09196 15.0294 5.25 14.6478 5.25 14.25V12.75H2.25Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6419 20.5584C17.5269 20.5584 17.4336 20.4651 17.4336 20.3501C17.4336 20.235 17.5269 20.1417 17.6419 20.1417",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6418 20.5584C17.7569 20.5584 17.8502 20.4651 17.8502 20.3501C17.8502 20.235 17.7569 20.1417 17.6418 20.1417",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6418 17.9751V13.8084",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5841 10.682C18.5015 10.5137 18.3733 10.3719 18.2141 10.2728C18.0549 10.1736 17.8711 10.121 17.6836 10.121C17.496 10.121 17.3123 10.1736 17.1531 10.2728C16.9939 10.3719 16.8657 10.5137 16.783 10.682L11.5203 21.4033C11.4569 21.5321 11.4275 21.675 11.4347 21.8184C11.4419 21.9619 11.4855 22.1011 11.5614 22.2229C11.6374 22.3448 11.7431 22.4453 11.8687 22.515C11.9943 22.5847 12.1356 22.6212 12.2792 22.621H23.088C23.2316 22.6212 23.3729 22.5847 23.4985 22.515C23.624 22.4453 23.7298 22.3448 23.8057 22.2229C23.8817 22.1011 23.9253 21.9619 23.9325 21.8184C23.9397 21.675 23.9102 21.5321 23.8469 21.4033L18.5841 10.682Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCarActionsImperfects;